import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import classes from './dashboard.module.css';
import AdminNavbar from '../navbar/adminNavbar';
import { MetricStatCard, TripStatCard } from './DashboardStatCard';
import { formatCount } from './dashboardFormat';
import { loadDashboardStats } from './loadDashboardStats';

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await loadDashboardStats();
        if (!cancelled) setStats(data);
      } catch (e) {
        if (!cancelled) setError('Could not load dashboard stats.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const s = stats || {
    flights: { booked: 0, cancelled: 0 },
    buses: { booked: 0, cancelled: 0 },
    hotels: { booked: 0, cancelled: 0 },
    holidays: { booked: 0, cancelled: 0 },
    cabBookings: { booked: 0, cancelled: 0 },
    customers: 0,
    todayBus: 0,
    todayBookings: 0,
    totalRevenue: '—',
    apiWalletBalance: '—',
  };

  return (
    <>
      <div className={classes.Head}>
        <AdminNavbar />
        <div className={classes.DashboardWrap}>
          <div className={classes.OverviewPanel}>
            <div className={classes.OverviewHeader}>
              <div className={classes.Eyebrow}>Admin overview</div>
              <h1 className={classes.OverviewTitle}>Dashboard</h1>
              {error ? <p className={classes.ErrorText}>{error}</p> : null}
            </div>

            <Row className={classes.StatRow}>
              <Col lg={3} md={6} xs={12} className={classes.StatCol}>
                <TripStatCard
                  title="Flights"
                  iconClass="fas fa-plane"
                  booked={s.flights.booked}
                  cancelled={s.flights.cancelled}
                />
              </Col>
              <Col lg={3} md={6} xs={12} className={classes.StatCol}>
                <TripStatCard
                  title="Buses"
                  iconClass="fas fa-bus"
                  booked={s.buses.booked}
                  cancelled={s.buses.cancelled}
                />
              </Col>
              <Col lg={3} md={6} xs={12} className={classes.StatCol}>
                <TripStatCard
                  title="Accommodation"
                  iconClass="fas fa-hotel"
                  booked={s.hotels.booked}
                  cancelled={s.hotels.cancelled}
                />
              </Col>
              <Col lg={3} md={6} xs={12} className={classes.StatCol}>
                <TripStatCard
                  title="Holidays"
                  iconClass="fas fa-luggage-cart"
                  booked={s.holidays.booked}
                  cancelled={s.holidays.cancelled}
                />
              </Col>
            </Row>

            <Row className={classes.StatRow}>
              <Col lg={3} md={6} xs={12} className={classes.StatCol}>
                <MetricStatCard
                  title="Total customers"
                  iconClass="fas fa-users"
                  value={formatCount(s.customers)}
                  loading={loading}
                />
              </Col>
              <Col lg={3} md={6} xs={12} className={classes.StatCol}>
                <MetricStatCard
                  title="Today's bookings"
                  iconClass="fas fa-calendar-day"
                  value={formatCount(s.todayBookings)}
                  loading={loading}
                />
              </Col>
              <Col lg={3} md={6} xs={12} className={classes.StatCol}>
                <MetricStatCard
                  title="Today's bus bookings"
                  iconClass="fas fa-bus"
                  value={formatCount(s.todayBus)}
                  loading={loading}
                />
              </Col>
              <Col lg={3} md={6} xs={12} className={classes.StatCol}>
                <TripStatCard
                  title="Cab"
                  iconClass="fas fa-car"
                  booked={s.cabBookings.booked}
                  cancelled={s.cabBookings.cancelled}
                />
              </Col>
            </Row>

            <Row className={classes.StatRow}>
              <Col lg={6} md={6} xs={12} className={classes.StatCol}>
                <MetricStatCard
                  title="Total revenue"
                  iconClass="fas fa-money-bill-alt"
                  value={s.totalRevenue}
                  loading={loading}
                />
              </Col>
              <Col lg={6} md={6} xs={12} className={classes.StatCol}>
                <MetricStatCard
                  title="API wallet balance"
                  iconClass="fas fa-wallet"
                  value={s.apiWalletBalance}
                  loading={loading}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
